import { Modal } from 'react-daisyui'
import { Button } from '@/components/Button.tsx'
import { useEffect, useRef } from 'react'
import { useProfile } from '@/stores/useAuth.ts'
import { useDrives } from '@/stores/useDrives.ts'
import { useTranslation } from 'react-i18next'

const hasSeenKey = 'demo-hello-modal'

export default function DemoHelloModal() {
  const { t } = useTranslation()
  const { profile } = useProfile()
  const { currentDrive } = useDrives()
  const modalRef = useRef<HTMLDialogElement>(null)

  function onOkClick() {
    localStorage.setItem(hasSeenKey, 'true')
    modalRef.current!.close()
  }

  useEffect(() => {
    if (!profile || !currentDrive) {
      return
    }

    if (currentDrive.author !== profile.username) {
      return
    }

    if (!currentDrive.is_demo) {
      return
    }

    const hasSeen = localStorage.getItem(hasSeenKey)
    if (hasSeen === null || hasSeen === 'false') {
      modalRef.current!.showModal()
    }
  }, [profile, currentDrive]);

  return <Modal ref={modalRef}>
    <Modal.Body>
      <div className='flex flex-col items-center gap-3 text-center'>
        <p>
          <span className='text-3xl'>
            Herzlich Willkommen
          </span>
        </p>
        <p>Das hier ist deine persönliche FridaySnap Demo.</p>
        <p>So könnte deine Galerie aussehen. Teste dich einfach mal durch! 😊</p>
        <p className='my-2'>Bei Fragen sind wir wie immer auf <a className='text-primary'
                                                                href='https://wa.me/496987000170'
                                                                target='_blank'>WhatsApp</a> erreichbar</p>
        <p className='mb-2'>{t('common.bestRegards')}, Dennis</p>
        <Button color='primary' className='px-5' onClick={onOkClick}>OK</Button>
      </div>
    </Modal.Body>
  </Modal>
}
